module.exports = __webpack_public_path__ + "img/default.dfb72a92.png";